import { render } from "./pay.vue?vue&type=template&id=3e7c7542&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"

import "./pay.vue?vue&type=style&index=0&id=3e7c7542&lang=scss&scoped=true"
import "./pay.vue?vue&type=style&index=1&id=3e7c7542&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7c7542"]])

export default __exports__